import Share from "./share";

export default class {
  constructor(options) {
    const defaults = {
      el: '[data-canvas-result]'
    };

    this.options = $.extend(true, {}, defaults, options);
    this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
    return this;
  }


  get() {
    this.$el = $(this.$el);
    return this;
  }

  init() {



    this.updateImageBlob();
  }

  updateImageBlob() {
    const canvas = document.getElementById("drawingCanvas");
    const context = canvas.getContext("2d");
    const width = this.$el.width();
    const height= this.$el.height();
    const title = "Наш будущий проект от однорукого копирайтера";
    const titleLength = $('.share-img-block__title').text(title).width();
    const leftTitle = (width / 2) - (titleLength / 2);
    const textBlock = $('.share-img-block__text');

    /*const imgWidth = 100;
    const imgHeight = 100;*/
    const imgWidth = 150;
    const imgHeight = 150;
    //const imgTop = 400;
    const imgTop = 160;
    //const imgLeft = 150;
    const imgLeft = -90;

    let leftText;
    let imgMass = [];
    let imgName = '';

    const text = $('.js-result-text').text();

    const textMass = this.getTextStr(text);

    $('.cards-wrapper__item').each(function () {
      let resImg = $(this).find('.card-item').get([0]);
      imgMass.push(resImg);
      let imgNameMass = [];

      $(this).find('.card-item').each(function () {
        imgNameMass.push($(this).attr('src'));
      });

      let nameMass = imgNameMass[0].split('/');

      imgName += nameMass[nameMass.length - 1].split('.')[0];

    });

    let img = new Image();

    img.onload = function() {
      context.clearRect(0, 0, width, height);
      context.fillRect(0,0, width, height);
      //context.translate(-imageCenter[0], -imageCenter[1]);
      context.drawImage(img, 0, 0);


      /*context.textBaseline = "top";
      context.font = "28px HelveticaNeue, sans";
      context.fillStyle = "white";
      context.fillText(title, leftTitle, 80);*/
      textMass.forEach(function (value, index) {

        textBlock.text(value);
        //leftText = (width / 2) - (textBlock.width() / 2);
        leftText = 0;
        leftText = 200;
        context.textAlign = 'left';
        context.textBaseline = "top";
        context.font = "40px HermesC, sans";
        //context.font = "41px HelveticaBlack, sans";
        //context.fillStyle = "white";
        context.fillStyle = "black";
        //context.fillText(value, leftText, 160 + 40 * index);
        context.fillText(value, leftText, 400 + 40 * index);
      });

      imgMass.forEach(function (value, index) {

        //context.drawImage(value, imgLeft + (200 * (index + 1)), imgTop, imgWidth, imgHeight);
        context.drawImage(value, imgLeft + (295 * (index + 1)), imgTop, imgWidth, imgHeight);
      });

     const imageBlob = dataURLToBlob(canvas.toDataURL('image/jpeg'));

     console.log(imgName);

      uploadCanvasData(imageBlob, imgName);
    };

    img.src = this.$el.attr('data-src');
  }

  getTextStr(text) {
    let arr = text.split(' ');
    let str = '';
    let strMass = [];
    let isInMass = false;
    let someStr;
    const textBlock = $('.share-img-block__text');
    do {

      someStr = str + arr[0] + ' ';

      if (textBlock.text(someStr).width() < 820) {
        str += arr[0] + ' ';
        isInMass = false;
      } else {

        if (!isInMass) {
          strMass.push(str);
          str = arr[0] + ' ';
          isInMass = true;
          if (arr.length == 1) {
            strMass.push(str);
          }
        } else {
          str += arr[0] + ' ';
        }
      }
      arr.splice(0, 1);
    } while (arr.length > 0) ;
    if (!isInMass) {
      strMass.push(str);
    }

    return strMass;

  }
  render() {
    if (this.$el.length) {
      this
        .get()
        .init();
    }
  }
}

let dataURLToBlob = function(dataURL) {
  const BASE64_MARKER = ';base64,';
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    let parts = dataURL.split(',');
    let contentType = parts[0].split(':')[1];
    let raw = parts[1];

    return new Blob([raw], {type: contentType});
  }

  let parts = dataURL.split(BASE64_MARKER);
  let contentType = parts[0].split(':')[1];
  let raw = window.atob(parts[1]);
  let rawLength = raw.length;

  let uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], {type: contentType});
};

let uploadCanvasData = function(imageBlob, name) {

  const data = new FormData();
  //name = 'sample-share';
  data.append('imageData', imageBlob);
  data.append('imageName', name);

  const img = $('[data-share]').attr('data-base-url') + '/img/_content/share/' + name + '.png';
  const str = $('[data-share]').attr('data-base-url') + '/?result=' + name;

  console.log(img);

  $('[data-share]').attr('data-url', str);
  $('[data-share]').attr('data-code', name);
  $('[data-share]').attr('data-image', img);

  $(window).trigger('share.bindEvents');

  $.ajax({
    url: '/api/share-img/',
    data: data,
    cache: false,
    contentType: false,
    processData: false,
    type: 'POST',
    error: function(xhr, status, error) {
      //let err = eval("(" + xhr.responseText + ")");
      console.log(status);
    },
    complete: function() {
      console.log('ajax finish');
    }
  });
};



// WEBPACK FOOTER //
// ./_src/js/modules/shareImg.js